// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"553":"82c1826f","689":"82c1826f"}[chunkId] + ".chunk.css";
};